export default __webpack_public_path__ + "static/media/3.ccaa5326.svg";